<template> 
  <md-dialog :md-active.sync="isOpen" class="edit-insured-modal">
    <md-dialog-title style="margin-bottom: 12px; font-weight: 700;">Edit Insured Information</md-dialog-title>

    <md-dialog-content style="padding: 0 24px;">
      <div>
        <label :class="{ 'md-invalid': errors.has('patientRelationshipToInsured') }">
          Patient relationship to insured
        </label>
        <md-field style="margin: 0;"
          :class="{
            'md-invalid': errors.has('patientRelationshipToInsured'),
          }"
        >
          <md-icon>assignment_ind</md-icon>
            <md-select
              v-model="form.patientRelationshipToInsured"
              v-validate="'required'"
              name="patientRelationshipToInsured"
            >
            <md-option :value="''" disabled selected hidden>
              Select relationship
            </md-option>
          
            <md-option
              v-for="(option, index) in relationshipOptions"
              :key="index"
              :value="option"
            >
              {{ option }}
            </md-option>
          </md-select>
        </md-field>
      </div>

      <div v-show="showPersonFields" style="display: flex; gap: 12px; width: 100%;">
        <div style="flex: 1;">
          <md-field :class="{
            'md-invalid': errors.has('firstName'),
          }">
            <label :style="errors.has('firstName') ? 'color: #ff1744 !important;' : ''">First Name</label>
            <md-input 
              v-model="form.firstName" 
              v-validate="validationRules.firstName"
              name="firstName"
              data-vv-name="firstName"
              data-vv-validate-on="none"
            />
          </md-field>
        </div>
        <div style="flex: 1;">
          <md-field :class="{
            'md-invalid': errors.has('lastName'),
          }">
            <label :style="errors.has('lastName') ? 'color: #ff1744 !important;' : ''">Last Name</label>
            <md-input 
              v-model="form.lastName" 
              v-validate="validationRules.lastName"
              name="lastName"
              data-vv-name="lastName"
              data-vv-validate-on="none"
            ></md-input>
          </md-field>
        </div>
      </div>

      <div v-show="showPersonFields">
        <md-field style="margin: 0;" :class="{ 'md-error': errors.has('gender') }">
          <md-icon style="margin-right: 0; padding-right: 10px; margin-top:12px; margin-left: 0;">man_4</md-icon>

          <div style="display: flex; gap: 20px; margin-top: 5px; margin-left: 0">
            <md-radio style="top: -5px; margin-left: 15px; "
              v-model="form.gender" 
              value="Male"
              v-validate="validationRules.gender"
              data-vv-name="gender"
              data-vv-validate-on="change"
            >
              <span
                style="top: -9px; position: absolute; font-size: 14px">Male</span>
            </md-radio>
          
            <md-radio style="top: -5px; margin-left: 15px; "
              v-model="form.gender" 
              value="Female"
              v-validate="validationRules.gender"
              data-vv-name="gender"
              data-vv-validate-on="change"
            >
              <span
                style="top:-9px; position: absolute; font-size: 14px">Female</span>
            </md-radio>
          </div>
        </md-field>
      </div>


      <div style="margin: 0; display: flex; flex-direction: column; border-bottom: solid 1px #ccc !important" v-show="showPersonFields" :class="{
        'md-invalid': errors.has('dob'),
      }">
        <label style="color: #aaa; font-size: .6875rem; line-height: 1.4; font-weight: 400;" :style="errors.has('dob') ? 'color: #ff1744 !important;' : ''">Date of Birth</label>

          <input style="font-size: 14px; color: #3c4858 ;" 
            type="date" 
            v-model="dobFormatted"
            name="dob"
            v-validate="validationRules.dob"
            data-vv-name="dob"
            data-vv-validate-on="none"
          ></input>
      </div>

      <md-field :class="{
        'md-invalid': errors.has('insuranceId'),
      }">
        <label :style="errors.has('insuranceId') ? 'color: #ff1744 !important;' : ''">Insured ID</label>
        <md-input 
          v-model="form.insuranceId"
          v-validate="validationRules.insuranceId"
          name="insuranceId"
          data-vv-name="insuranceId"
          data-vv-validate-on="none"
        />
      </md-field>

      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-field :class="{
            'md-invalid': errors.has('insurance'),
          }">
            <label :style="errors.has('insurance') ? 'color: #ff1744 !important;' : ''">
              Company
            </label>
            <md-input 
              v-model="form.insurance"
              v-validate="validationRules.insurance"
              name="insurance"
              data-vv-name="insurance"
              data-vv-validate-on="none"
            />
          </md-field>
        </div>
        <div class="md-layout-item">
          <md-field :class="{'md-error': errors.has('groupNumber') }">
            <label :style="errors.has('groupNumber') ? 'color: #ff1744 !important;' : ''">
              Group Number
            </label>
            <md-input 
              v-model="form.groupNumber"
              v-validate="validationRules.groupNumber"
              name="groupNumber"
              data-vv-name="groupNumber"
              data-vv-validate-on="none"
            />
          </md-field>
        </div>
      </div>

      <md-field v-show="showPersonFields" :class="{
        'md-invalid': errors.has('address'),
      }">
        <label :style="errors.has('address') ? 'color: #ff1744 !important;' : ''">Address</label>

        <md-input 
          v-model="form.address" 
          v-validate="validationRules.address"
          name="address"
          data-vv-name="address"
          data-vv-validate-on="none"
        ></md-input>
      </md-field>

      <div style="display: flex; gap: 12px; width: 100%;">
        <div style="flex: 1" v-show="showPersonFields">
          <md-field :class="{
            'md-invalid': errors.has('city'),
          }">
            <label :style="errors.has('city') ? 'color: #ff1744 !important;' : ''">City</label>

            <md-input 
              v-model="form.city" 
              v-validate="validationRules.city"
              name="city"
              data-vv-name="city"
              data-vv-validate-on="none"
            ></md-input>
          </md-field>
        </div>
        <div style="flex: 1" v-show="showPersonFields">
          <md-field :class="{
            'md-invalid': errors.has('state'),
          }"> 
            <label :style="errors.has('state') ? 'color: #ff1744 !important;' : ''">State</label>

            <md-select
              v-validate="validationRules.state"
              id="state-select"
              ref="stateInput"
              v-model="form.state"
              name="state"
              data-vv-name="state"
              data-vv-validate-on="none"
              md-dense
            >
              <md-option
                v-for="state in states"
                :key="state.LookupId"
                :value="state.LookupId"
              >
                {{ state.DisplayValue }}
              </md-option>
            </md-select>
          </md-field> 
        </div>
      </div>

      <div style="display: flex; gap: 12px; width: 100%;" v-show="showPersonFields">
        <div style="flex: 1">
          <md-field :class="{
            'md-invalid': errors.has('zip'),
          }">
            <label :style="errors.has('zip') ? 'color: #ff1744 !important;' : ''">Zip</label>
            <md-input 
              v-model="form.zip" 
              v-validate="validationRules.zip"
              name="zip"
              data-vv-name="zip"
              data-vv-validate-on="none"
            ></md-input>
          </md-field>
        </div>
        <div class="md-size-50" style="flex: 1">
          <md-field :class="{
            'md-invalid': errors.has('country'),
          }">
            <md-icon>outlined_flag</md-icon>
            <label :style="errors.has('country') ? 'color: #ff1744 !important;' : ''">Country</label>
            <md-select
              v-validate="validationRules.country"
              id="country-select"
              ref="countryInput"
              v-model="form.country"
              name="country"
              data-vv-name="country"
              data-vv-validate-on="none"
              md-dense
            >
              <md-option
                v-for="country in countries"
                :key="country.LookupId"
                :value="country.LookupId"
              >
                {{ country.DisplayValue }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-primary" @click="close">Cancel</md-button>
      <md-button class="md-primary" @click="validateBeforeSave">Save</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex"
import { SlideYDownTransition } from "vue2-transitions"
import Swal from "sweetalert2"
import VeeValidate from 'vee-validate';

export default {
  name: "EditInsuredInformationsModal",
  components: {
    SlideYDownTransition
  },
  props: {
    isOpen: Boolean,
    patientInfo: Object,
    insuredInfo: Object
  },
  data() {
    return {
      form: {
        patientUserId: "",
        patientId: "",
        firstName: "",
        lastName: "",
        dob: "",
        insurance: "",
        insuranceId: "",
        groupNumber: "",
        patientRelationshipToInsured: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        gender: ''
      },
      relationshipOptions: [
        'Self',
        'Spouse',
        'Child',
        'Life Partner',
        'Employee',
        'Organ Donor',
        'Cadaver Donor',
        'Other',
        'Unknown'
      ],
      state: "",
      country: "",
      states: [],
      countries: [],
      countrySwitch: true,
      countryFilterKeys: "",
      API_SERVICE: process.env.VUE_APP_URL,
    };
  },
  created: function() {
  },
  mounted() {
    this.defineLookups();
    this.$nextTick(() => {
      if (!this.$validator) {
        console.error('VeeValidate validator not available');
      } else {
        Object.keys(this.$validator.fields).forEach(fieldName => {
          const field = this.$validator.fields[fieldName];
          field.touched = false;
        });
      }
    });
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.loadData();
      }
    },
  },
  computed: {
    getFormattedAge() {
      const birth = this.getDob
      const age = this.getAge

      if (!birth || !age) return "-"
      return `<span>${this.getDob}&nbsp;&nbsp;&nbsp;&nbsp;[ ${age} ]</span>`
    },
    dobFormatted: {
      get() {
        return this.form.dob
          ? new Date(this.form.dob).toISOString().split('T')[0]
          : '';
      },
      set(value) {
        this.form.dob = value;
      }
    },
    showPersonFields() {
      return this.form.patientRelationshipToInsured != 'Self';
    },
    validationRules() {
      const shouldValidate = this.form.patientRelationshipToInsured && 
        this.form.patientRelationshipToInsured.toLowerCase() !== 'self';
      
      return {
        firstName: shouldValidate ? { required: true } : false,
        lastName: shouldValidate ? { required: true } : false,
        dob: shouldValidate ? { required: true } : false,
        gender: shouldValidate ? { required: true } : false,
        address: shouldValidate ? { required: true } : false,
        city: shouldValidate ? { required: true } : false,
        state: shouldValidate ? { required: true } : false,
        zip: shouldValidate ? { required: true } : false,
        country: shouldValidate ? { required: true } : false
      };
    }
  },
  methods: {
    ...mapActions(["listLookupsByMasterName"]),
    submitForm() {
      this.$emit("submit", {
        stateId: this.selectedStateId
      })
    },
    loadData() {
      this.form = {
        insuredPersonId: (this.patientInfo && this.patientInfo.insuredPersonID) || "",
        patientUserId: (this.patientInfo && this.patientInfo.patientUserID) || "",
        lastName: (this.insuredInfo && this.insuredInfo.lastName),
        firstName: (this.insuredInfo && this.insuredInfo.firstName),
        insuranceId: (this.patientInfo && this.patientInfo.insuranceID) || "",
        groupNumber: (this.patientInfo && this.patientInfo.groupNumber) || "",
        insurance: (this.patientInfo && this.patientInfo.insurance) || "",
        patientRelationshipToInsured: (this.patientInfo && this.patientInfo.relationshipToInsured) || "self",
        dob: (this.insuredInfo && this.insuredInfo.dob),
        gender: (this.insuredInfo && this.insuredInfo.gender) || "",
        address: (this.insuredInfo && this.insuredInfo.address.address) || "",
        city: (this.insuredInfo && this.insuredInfo.address.city) || "",
        state: (this.insuredInfo && this.stringToLookup(this.states, this.insuredInfo.address.state)) || "",
        zip: (this.insuredInfo && this.insuredInfo.address.zip) || "",
        country: (this.insuredInfo && this.stringToLookup(this.countries, this.insuredInfo.address.country)) || ""
      };
    },
    close() {
      this.$emit("close");
    },
    async save() {
      try {
        const userId = sessionStorage.getItem("userID");
        const url = `${this.API_SERVICE}/patient/insured-informations/${userId}`;
        await window.axios.put(url, { ...this.form });
        this.$emit("saved");
        this.close();
      } catch (error) {
        console.error(error);
        Swal.fire({
          title: "Error!",
          text: "An error occurred while updating insured information",
          icon: "error"
        });
      }
    },
    async defineLookups() {
      try {
        const [states, countries] = await Promise.all([
          this.fetchLookupByName("States"),
          this.fetchLookupByName("CountryCodes")
        ]);
      
        this.states = states;
        this.countries = countries;
      
        this.loadData();
      } catch (error) {
        console.error("Error fetching lookups:", error);
      }
    },
    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },
    defineGender(gender) {
      if (!gender) return ""
      switch (gender.toLowerCase()) {
        case "male":
          return "Male"
        case "female":
          return "Female"
        default:
          return ""
      }
    },
    stringToLookup(lookupList, input) {
      if (!Array.isArray(lookupList) || lookupList.length === 0 || !input) {
        return null;
      }

      const num = parseInt(input, 10);
      const search = String(input).toLowerCase();

      const found = lookupList.find(item =>
        item.LookupId === num ||
        (item.Name || "").toLowerCase() === search ||
        (item.Value || "").toLowerCase() === search
      );
      return found ? found.LookupId : null;
    },
    countryClearFilter() {
      this.countryFilterKeys = ""
    },
        countryFind(event) {
      if (event.key === "Enter") {
        this.reRenderCountry()
        this.reRenderBizphone(true)
      }
      if (event.key === "Escape") {
        this.countryFilterKeys = ""
      }
      if (event.key === "Backspace") {
        this.countryFilterKeys = this.countryFilterKeys.substring(0, this.countryFilterKeys.length - 1)
      }
      if (event.key.length > 1) return

      this.countryFilterKeys += event.key

      let foundCountry = this.countries.find((country) => {
        return country.DisplayValue.toLowerCase().startsWith(this.countryFilterKeys.toLowerCase())
      })

      this.country = foundCountry
      let value = this.countries.indexOf(foundCountry) * 43
      let countryID = $("#" + foundCountry)
      let scrollParent = $(countryID).parent().parent()

      $(scrollParent).scrollTop(value)
    },
    async validateBeforeSave() {
      try {
        Object.keys(this.$validator.fields).forEach(fieldName => {
          const field = this.$validator.fields[fieldName];
          field.touched = true;
        });
      
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
          return; 
        }

        await this.save();
      } catch (error) {
        console.error('Validation error:', error);
        Swal.fire({
          title: "Error",
          text: "An error occurred during validation",
          icon: "error"
        });
      }
    },
    debugValidation() {
      console.group('[DEBUG] Validation State');
      console.log('All errors:', this.errors.all());
      Object.keys(this.$validator.fields).forEach(name => {
        const field = this.$validator.fields.find({ name });
        console.log(`Field "${name}" →`, field, 'Errors:', this.errors.first(name));
      });
      console.groupEnd();
    }
  }
};
</script>

<style scoped>
.edit-insured-modal {
  max-width: 600px;
}

.md-invalid {
  border-color: #ff1744 !important;
}

.md-error {
  color: #ff1744;
  font-size: 12px;
  margin-top: 3px;
}

label {
  transition: color 0.3s ease;
}
</style>
